import { createBlacklistFilter } from "redux-persist-transform-filter";

const createReduxBlacklist = (blacklistItems = []) => {
  return blacklistItems.map(({ reducer, key }) => {
    return createBlacklistFilter(reducer, [key]);
  });
};

export default createReduxBlacklist;
